import type { FunctionComponent } from 'react';

import { BreakPoints } from '@kanda-libs/ks-design-library';

import Desktop from './Desktop';
import Mobile from './Mobile';
import usePayByCardProps from './usePayByCardProps';

const PayByCard: FunctionComponent = function () {
  const props = usePayByCardProps();
  return (
    <BreakPoints
      mobile={<Mobile {...props} />}
      desktop={<Desktop {...props} />}
    />
  );
};
export default PayByCard;
